/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Italian (Italy)
export default {
  'fabric.reactions.add': 'Aggiungi una reazione',
  'fabric.reactions.error.unexpected': 'Le reazioni non sono temporaneamente disponibili',
  'fabric.reactions.loading': 'Caricamento in corso...',
  'fabric.reactions.more.emojis': 'Altre emoji',
  'fabric.reactions.other.reacted.users': '{count, plural, one {e un altro} other {e altri {count}}}',
  'fabric.reactions.reactwithemoji': "Reagisci con l'emoji {emoji}",
  'fabric.reactions.summary': 'Visualizza tutte le reazioni degli utenti',
  'reaction-picker-trigger.add.reaction.message': 'Aggiungi una reazione',
  'reactions.dialog.close': 'Chiudi',
  'reactions.dialog.emoji.name': '{emojiName}',
  'reactions.dialog.left.navigate': 'Navigazione a sinistra',
  'reactions.dialog.reactions.count':
    '{count, plural, one {{count,number} reazione in totale} other {{count,number} reazioni in totale}}',
  'reactions.dialog.right.navigate': 'Navigazione a destra',
  'reactions.dialog.viewall': 'Visualizza tutto',
  'reactions.dialog.viewall.tooltip': 'Visualizza tutte le reazioni degli utenti',
};
